export default __webpack_public_path__ + "static/media/slTopic.ec8c16db.jpg";